import { render } from "./LoginPage.vue?vue&type=template&id=cc27c16c&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=cc27c16c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cc27c16c"

export default script